<template>
    <div :class="classList">
        <RouterLink v-if="item.routeName && !item.disabled" :to="{ name: item.routeName }">
            <SrListItem>
                <SrListItemIcon v-if="item.icon" class="ml-0 mr-3">
                    <SrIcon size="s" :active="isActive" :icon="item.icon" />
                </SrListItemIcon>
                <SrListItemTitle class="sr-navigation-bar-item__title" v-text="item.title" />
            </SrListItem>
        </RouterLink>
        <SrListItem v-else :disabled="item.disabled">
            <SrListItemIcon v-if="item.icon" class="ml-0 mr-3">
                <SrIcon size="s" :active="isActive" :icon="item.icon" />
            </SrListItemIcon>
            <SrListItemTitle class="sr-navigation-bar-item__title" v-text="item.title" />
        </SrListItem>
    </div>
</template>

<script>
import SrIcon from '../SrIcon/SrIcon';
import SrListItem from '../SrListItem/SrListItem';
import SrListItemIcon from '../SrListItemIcon/SrListItemIcon';
import SrListItemTitle from '../SrListItemTitle/SrListItemTitle';
import { USER_INPUT_CLASS } from '../../utils/classNames';

const ELEMENT_CLASS = 'sr-navigation-bar-item';

export default {
    name: 'SrNavigationBarItem',
    components: { SrIcon, SrListItem, SrListItemIcon, SrListItemTitle },
    props: {
        item: {
            type: Object,
            required: true,
        },
        isActive: {
            type: Boolean,
            default: false,
        },
        borderLess: Boolean,
    },
    computed: {
        classList() {
            return {
                [ELEMENT_CLASS]: true,
                [USER_INPUT_CLASS]: true,
                'no-border': this.borderLess,
            };
        },
    },
};
</script>
